import { SessionProvider } from "@mojo/auth/react";
import { BrandProp } from "@mojo/types";
import React from "react";
import Sidenav from "../MyMojo/Sidenav";
import { TemplateContext } from "./context";
import { Footer } from "./Footer";
import { Grid } from "./Grid";
import { Main } from "./Main";
import { BasicNav } from "./Nav/Basic";
import { SideNavRelativeContainer, SideNavWrapperContainer, VanillaTemplate } from "./styles/base.css";

export type TemplateProps =
  & {
    children: React.ReactNode;
    variant?: "gray" | "orange" | "yellow-wave" | "gray-wave";
    withSideNav?: {
      baseUrl: string;
    };
  }
  & React.HTMLAttributes<HTMLDivElement>
  & BrandProp;

/**
 * Template wraps all other templating components. It sets context,
 * changes background colors and puts things in the correct order.
 */
const Template = ({
  children,
  brand = "Mojo",
  variant = "gray",
  withSideNav,
  ...props
}: TemplateProps) => {
  const [navHeight, setNavHeight] = React.useState(0);
  const [mainHeight, setMainHeight] = React.useState(0);

  const SideNavWrapper = (children: React.ReactNode) => {
    if (withSideNav !== undefined) {
      return (
        <div className={SideNavWrapperContainer}>
          <div className={SideNavRelativeContainer}>
            <Sidenav baseUrl={withSideNav.baseUrl} />
          </div>
          <div style={{ flex: 1 }}>
            <SessionProvider>{children}</SessionProvider>
          </div>
        </div>
      );
    }
    return children;
  };

  return (
    <TemplateContext.Provider
      value={{ navHeight, setNavHeight, mainHeight, setMainHeight }}
    >
      {SideNavWrapper(
        <div
          {...props}
          className={`
          mojo__template
          ${VanillaTemplate({ brand, variant })}
          ${props.className || ""}
        `}
        >
          {children}
        </div>,
      )}
    </TemplateContext.Provider>
  );
};

export default Template;
export { BasicNav, Footer, Grid, Main };
